module.exports = __webpack_public_path__ + "static/media/exit.63002100.svg";